import CoreApiService from "../../system/api/coreApiService";
import { MovementRequest } from "../../libs/core-api-requests/documents/movementRequest";
import { DocumentDataProviderV2 } from "./Common/DocumentDataProviderV2";
import {  IMovementCreateDTO, IMovementGetDTO, IMovementUpdateDTO, IMovementViewDTO } from "../../libs/coreapi-dto/documents/movement";
import { IMovementItemGetDTO, IMovementItemViewDTO } from "../../libs/coreapi-dto/documents/movementItem";
import { GtinListInfoDto } from "../../@types/kiz";


export class MovementDataProvider extends DocumentDataProviderV2<IMovementViewDTO, IMovementGetDTO, IMovementCreateDTO, IMovementUpdateDTO, IMovementItemViewDTO, IMovementItemGetDTO>
{
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<MovementRequest> {
        return this._coreApiService.movementRequest;
    }

    checkSgtins(idDocumentGlobal: string, callback?: (response: any) => void, callbackFailed?: (e) => void) {
        this._coreApiService.kizRequest.then((r) => 
            r.checkSgtins(idDocumentGlobal, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    callbackFailed?.(e);
                }
            })
        );
    }

    getCheckSgtinsResult(taskId: string, idDocumentGlobal: string, callback?: (response: GtinListInfoDto) => void, callbackFailed?: (e) => void) {
        this._coreApiService.kizRequest.then((r) => 
            r.getCheckSgtinsResult(taskId, idDocumentGlobal, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.(e.data);
                } else {
                    callbackFailed?.(e);
                }
            })
        );
    }

    logIgnoreCheck(idDocumentGlobal: string, callback?: () => void, callbackFailed?: (e) => void) {
        this._coreApiService.kizRequest.then((r) => {
            if (typeof r.logIgnoreCheck !== 'function') {
                callbackFailed?.(new Error("logIgnoreCheck method not found"));
                return;
            }
            r.logIgnoreCheck(idDocumentGlobal, (e) => {
                if (e.respType === "isCompleted") {
                    callback?.();
                } else {
                    callbackFailed?.(e);
                }
            });
        });
    }
}